import React, { useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import { authenticationService } from "../../../src/_services/authentication.service";
import "./login.css";

async function loginUser(credentials) {
  return fetch("https://voicehub.astroline.com:1443/api/v2/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  }).then(async (data) => {
    const tokenBody = await data.json();
    return tokenBody.access_token;
  });
}

export default function Login({ setToken }) {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const navigate = useNavigate();

  const setUser = (e) => {
    setUserName(e.target.value);
    sessionStorage.setItem("userName", e.target.value);
  };

  const setPass = (e) => {
    setPassword(e.target.value);
  };

  function getToken() {
    const tokenString = sessionStorage.getItem("tokenStats");
    return tokenString;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const token = await loginUser({
      email: username,
      password: password,
    });
    setToken(token);
  };

  return (
    <div className="login">
      <div className="leftLogin">
        <div className="astrolineLogo"></div>
        <div className="statsPhoto"></div>
      </div>
      <div className="rightLogin">
        <div className="loginForm">
          <Formik
            initialValues={{
              username: "",
              password: "",
            }}
            validationSchema={Yup.object().shape({
              username: Yup.string().required("Username is required"),
              password: Yup.string().required("Password is required"),
            })}
            onSubmit={(
              { username, password },
              { setStatus, setSubmitting }
            ) => {
              setStatus();
              authenticationService.login(username, password).then(
                (user) => {
                  console.log(user);
                  sessionStorage.setItem("tokenStats", user.token);
                  sessionStorage.setItem("userName", user.username);
                  sessionStorage.setItem("cdr", user.cdr);
                  sessionStorage.setItem("realtime", user.realtime);
                  sessionStorage.setItem("tags", user.tags);
                  sessionStorage.setItem("stats", user.stats);
                  sessionStorage.setItem("api", user.api);
                  sessionStorage.setItem("manageUsers", user.manageUsers);
                  sessionStorage.setItem("company", user.company);
                  sessionStorage.setItem("krakenCalls", user.krakenCalls);
                  sessionStorage.setItem(
                    "userAlias",
                    user.firstName + " " + user.lastName
                  );
                  sessionStorage.setItem("pToken", user.pToken);
                  sessionStorage.setItem("extension", user.extension);
                  window.location.href = `${window.location.href}home`;
                },
                (error) => {
                  setSubmitting(false);
                  setStatus(error);
                }
              );
            }}
            render={({ errors, status, touched, isSubmitting }) => (
              <Form>
                <div className="inputs">
                  <label htmlFor="username">
                    Username<br></br>
                  </label>
                  <Field
                    name="username"
                    type="text"
                    className={
                      "inputs" +
                      (errors.username && touched.username ? " is-invalid" : "")
                    }
                    style={{
                      width: 500,
                      height: 60,
                      marginTop: 10,
                      borderWidth: 0.5,
                      borderRadius: 10,
                      borderColor: "#cccccc",
                    }}
                  />
                  <ErrorMessage
                    style={{
                      color: "red",
                    }}
                    name="username"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
                <br></br>
                <div className="inputs">
                  <label htmlFor="password">
                    Password<br></br>
                  </label>
                  <Field
                    name="password"
                    type="password"
                    className={
                      "form-control" +
                      (errors.password && touched.password ? " is-invalid" : "")
                    }
                    style={{
                      width: 500,
                      height: 60,
                      marginTop: 10,
                      borderWidth: 0.5,
                      borderRadius: 10,
                      borderColor: "#cccccc",
                    }}
                  />
                  <ErrorMessage
                    style={{
                      color: "red",
                    }}
                    name="password"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
                <div className="form-group">
                  <button
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      width: 500,
                      height: 60,
                      marginTop: 10,
                      border: 0,
                      borderRadius: 10,
                      backgroundColor: "#81d4ae",
                      color: "white",
                    }}
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                  >
                    Login
                  </button>
                  {isSubmitting && (
                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                  )}
                </div>
                {status && (
                  <div
                    style={{
                      color: "red",
                    }}
                    className={"alert alert-danger"}
                  >
                    <b>Username or Password invalid</b>
                  </div>
                )}
              </Form>
            )}
          />
        </div>
      </div>
    </div>
  );
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired,
};
